

function Home() {
  return (
    <div className="home-container">
      <h1>Welcome</h1>
      <p>
        Autistic full-stack developer with a unique angle on problem-solving.
      </p>
      <div className="home-links">
        <a href="/about">About Me</a>
        <a href="/projects">My Projects</a>
        <a href="/contact">Get in Touch</a>
        <a href="/links">Find Me Online</a>
      </div>
    </div>
  );
}

export default Home;
